import React from "react";
import DatePicker from "react-datepicker";
import moment from "moment";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import { setRedirectPath } from "../../modules/actions/authActions";
import { getCart } from "../../modules/actions/cartActions";
import { addToCart } from "../../modules/actions/cartActions";
import { addFlashMessage } from "../../modules/actions/flashMessages.js";
import getHistoryState from "history/createBrowserHistory";
import "react-datepicker/dist/react-datepicker.css";
import { Link, withRouter } from "react-router-dom";
import qs from "qs";
import { format } from "../../modules/utils"
import { getRechargeDeviceProduct, validateDeviceIMEI } from "../../modules/actions/productActions";
import { getCountries } from "../../modules/actions/countryActions";
import MaskedInput from 'react-text-mask'

class RechargeDeviceCart extends React.Component{

    constructor(props) {
        super(props);
        this.state = {
            cartType : "device_recharge",
            receiveType: "DELIVERY",
            returnType: "Mail",
            shippingFee: 0,
            startDate : moment(),
            useType : null,
            quantity: 1,
            product : {},
            orgProduct : {},
            country : {},
            hasAutoRenewal : false
        };
        this.props.getRechargeDeviceProduct();
        this.props.getCountries();
        this.countries = [];
    }

    onStartDateChange = date => {
        this.setState({
            startDate : date
        });
    };

    onEndDateChange = date => {
        this.setState({
            endDate : date
        });
    };


    _getSubTotal = (fraction = 2) => {
        let total = 0;
        let productTotal = this.getPriceByUseType(this.state.product);
        let recurringPrice = 0;
        if (typeof this.state.recurringProfile !== "undefined" && this.state.recurringProfile !== null){
            //recurringPrice = this.getPriceByUseType(this.state.recurringProfile);
            recurringPrice = this.state.recurringProfile.price;
        }
        total = parseFloat(productTotal) + parseFloat(recurringPrice);
        return total.toFixed(fraction);
    };

    calculateDeliveryCharges(receiveType){
        let price = 0;
        return price;
    }

    calculateReturnCharges(returnType){
        let price = 0;
        return price;
    }

    getCalculatedShipping = () => {
        let deliveryCharges = this.calculateDeliveryCharges(this.state.receiveType);
        let returnCharges = this.calculateReturnCharges(this.state.returnType);
        return parseFloat(deliveryCharges) + parseFloat(returnCharges);
    };

    showMessage(message){
        this.refs.notify.notificationAlert({
            place: "bl",
            message: (
                <div>
                    <div>
                        <b>{message}</b>
                    </div>
                </div>
            ),
            type: "danger",
            icon: "now-ui-icons ui-1_bell-53",
            autoDismiss: 7
        });
    };

    addToCart = () => {
        const { product, country, useType, receiveType, returnType, shippingFee, quantity, cartType, imei, hasAutoRenewal } = this.state;
        const sessionId = localStorage.getItem("sessionId");
        const productId = product._id;
        const subtotal = this._getSubTotal();
        const total = this._getSubTotal();
        // const startDate = this.state.startDate;
        // const endDate = moment(this.state.startDate).add(this.state.recurringProfile.period,this.state.recurringProfile.period_unit);

        /*
        console.log(this.state.errormessage);
        console.log(imei);
        console.log(this.state.validateImei);
        console.log(useType);
        console.log(this.state.setAssocProductId);
        console.log(this.state.recurringProfile);
        console.log(this.state.associatedProduct);
        */

        if (typeof imei === "undefined" || imei === null) {
            this.setErrorMessage("Please enter IMEI Number.");
            return;
        }

        if (typeof this.state.validateImei === "undefined" || !this.state.validateImei) {
            this.setErrorMessage("Your IMEI number is not verified. Please enter valid IMEI number and verify again.");
            this.setState({
                validateImei : false
            });
            return;
        }

        if (typeof useType === "undefined" || useType === null) {
            this.setErrorMessage("Please select a plan.");
            return;
        }

        if (useType === "GLOBAL" && (typeof country === "undefined" || country === null)) {
            this.setErrorMessage("Please select a Country.");
            return;
        }

        if (typeof this.state.setAssocProductId === "undefined" || this.state.setAssocProductId === null) {
            this.setErrorMessage("Please select Day Pass or Data Plan.");
            return;
        }

        if (typeof this.state.recurringProfile === "undefined" || this.state.recurringProfile === null || typeof this.state.associatedProduct === "undefined" || this.state.associatedProduct === null) {
            let assocProductName = "Data Plan";
            if(this.state.setAssocProductId === "5c76913ff7b6460023607206") {
                assocProductName = "Day Pass";
            }
            this.setErrorMessage("Please select a plan for " + assocProductName);
            return;
        }

        let startDate = "";
        let endDate = "";

        if (typeof this.state.startDate !== "undefined") {
            startDate = format(this.state.startDate);
        }

        if (typeof this.state.startDate !== "undefined" && typeof this.state.endDate !== "undefined") {
            startDate = format(this.state.startDate);
            endDate = this.endDate;
        }

        let recurring_profile_id = null;

        if (typeof this.state.recurringProfile !== "undefined" && this.state.recurringProfile !== null){
            recurring_profile_id = this.state.recurringProfile._id;
        }

        let associated_product_id = null

        if (typeof this.state.associatedProduct !== "undefined" && this.state.associatedProduct !== null){
            associated_product_id = this.state.associatedProduct._id;
        }

        let payload = {
            cartType,
            startDate,
            endDate,
            useType,
            receiveType,
            returnType,
            quantity,
            sessionId,
            total,
            subtotal,
            shippingFee,
            productId,
            product,
            country,
            imei,
            hasAutoRenewal,
            associated_product : associated_product_id,
            recurring_profile : recurring_profile_id
        };

        this.performCartAction(payload);
    };

    performCartAction(payload){
        const { auth } = this.props;
        if (auth.isAuthenticated) {
            this.props
                .addToCart(payload)
                .then(data => {
                    if (data.status) {
                        this.context.router.history.push({
                            pathname: "/checkout",
                            params : {
                                product: this.state.product
                            }
                        });
                    } else {
                        this.showMessage(data.message);
                    }
                })
                .catch(error => {
                    this.showMessage(error.response.data.message);
                });
        } else {
            this.props.setRedirectPath("/checkout", payload);
            this.context.router.history.push({
                pathname : "/login",
                params : {
                    product : payload.product,
                    cart : payload
                }
            });
        }
    }

    componentWillReceiveProps(nextProps, nextContext) {
        if(typeof this.state.country === "undefined" || this.state.country === null || Object.keys(this.state.country).length === 0) {
            console.log("nextProps", nextProps);
            if (typeof nextProps.products !== "undefined" && nextProps.products.length > 0) {
                let product = nextProps.products[0];
                this.setState({
                    orgProduct: {...product},
                    product: {...product},
                    total: this.getPriceByUseType(product)
                })
            }
            if (typeof nextProps.countries !== "undefined" && nextProps.countries.length > 0) {
                this.countries = nextProps.countries;
            }
        }
    }

    setErrorMessage(errorMessage){
        this.setState({
            errorMessage: errorMessage
        })
    }

    setUseType(useType){
        if(useType !== this.state.useType) {
            this.setState({
                useType: useType
            })
            this.setState({
                recurringProfile : null,
                associatedProduct : null,
                country : null
            });
            this.state.product.associated_products = this.state.orgProduct.associated_products;
        }
    }

    getCountryById(id){
        var country = this.countries.find((country) => {
            return id === country._id
        });
        return country;
    }

    onRecurringProfileSelect(associatedProduct,recurringProfile){
        this.setState({
            recurringProfile : recurringProfile,
            associatedProduct : associatedProduct
        });
    }

    isActivated(deviceInventory){
        if (typeof deviceInventory.status !== "undefined" && deviceInventory.status.toLowerCase() === "sold"){
            if(!this.state.validateImei) {
                this.setState({
                    errorMessage : null
                })
            }
            this.setState({
                validateImei : true
            })
        }else{
            this.setState({
                validateImei : false,
                errorMessage : "Your IMEI number is not verified. Please enter valid IMEI number and verify again."
            })
        }

        return true
    }

    reset(){
        this.state.imei = '';
        this.setState({
            validateImei : null,
            errorMessage : null,
            useType : null,
            recurringProfile : null,
            associatedProduct : null,
            country : null,
            hasAutoRenewal : false,
        });
        this.state.product.associated_products = this.state.orgProduct.associated_products;
    }

    _onChange = event => {
        const field = event.target.name;
        const value = event.target.value;

        this.setState({ [field]: value.trim() });

        if(field == 'imei') {
            this.setState({
                validateImei : null
            })
        }
        else if(field == 'country') {
            let useType = null;
            let country = this.getCountryById(value);
            if(country != null && typeof country.type !== "undefined" && country.type != null) {
                useType = country.type;
            }
            if(country != null && typeof country.associated_products !== "undefined" && country.associated_products != null && country.associated_products.length > 0) {
                this.state.product.associated_products = country.associated_products;
            }
            else {
                this.state.product.associated_products = this.state.orgProduct.associated_products;
            }
            this.setState({
                useType: useType,
                country: country,
                setAssocProductId : null,
                recurringProfile : null,
                associatedProduct : null
            });
        }
    }

    setAssociatedProduct(productId){
        if(productId !== this.state.setAssocProductId) {
            this.setState({
                setAssocProductId: productId
            })
            this.setState({
                recurringProfile : null,
                associatedProduct : null,
                startDate : moment()
            });
        }
    }

    getPriceByUseType(object){

        let price = 0;
        let useType = "USA";
        if (typeof this.state.useType !== "undefined"){
            useType = this.state.useType;
        }

        switch (useType) {
            case "USA" :
                price = object.domesticPrice;
                break;

            case "GLOBAL":
                price = object.globalPrice;
                break;
        }

        return price;
    }

    validateIMEI = () => {
        let { imei } = this.state;
        if(typeof imei === "undefined" || imei.trim() === '') {
            this.setState({
                validateImei : false,
                errorMessage : "Your IMEI number is not verified. Please enter valid IMEI number and verify again."
            })
        }
        else {
            this.props.validateDeviceIMEI(imei).then(
                res => {
                    if (res.status) {
                        this.state.hasAutoRenewal = res.hasAutoRenewal;
                        this.isActivated(res.device);
                    }
                },
                err => {
                    console.log("Request has error : ", err.error)
                }
            );
        }
    };

    render() {
        const { product } = this.state;
        //console.log(product.associated_products);

        return(
            <section className="BodyContainer">
                <div className="container">
                    <div className="row position-relative">

                        <div className="col-md-5 services_img_bg" >
                            <div className="col-lg-12">
                                <div className="m-product-title">
                                    MightyWifi <span className="Serif">Recharge</span>
                                </div>
                            </div>
                            <img src="/images/mightywifi-cloud-1.jpg" alt="Mightywifi US and Global hotspot wifi device" />
                            <div style={{clear:"both"}}></div>

                            <a href="/images/mightywifi-cloud-1.jpg" className="device-link-thumb" data-lightbox="image-1">
                                <img src="/images/mightywifi-cloud-1.jpg" className="device-thumb" style={{marginTop:"10px"}} alt="Mightywifi US and Global hotspot wifi device front image" />
                            </a>
                            <a href="/images/mightywifi-cloud-2.jpg" className="device-link-thumb" data-lightbox="image-2">
                                <img src="/images/mightywifi-cloud-2.jpg" className="device-thumb" style={{marginTop:"10px"}} alt="Mightywifi US and Global hotspot wifi device side image" />
                            </a>
                            <a href="/images/mightywifi-cloud-3.jpg" className="device-link-thumb" data-lightbox="image-3">
                                <img src="/images/mightywifi-cloud-3.jpg" className="device-thumb" style={{marginTop:"10px"}} alt="Mightywifi US and Global hotspot wifi device with case image" />
                            </a>
                            {/* <a href="/images/mighty5.jpg" data-lightbox="image-4">
                                <img src="/images/mighty5.jpg" className="device-thumb" style={{marginTop:"10px"}} alt="Mightywifi US and Global hotspot wifi device gaming image" />
                            </a>
                            <a href="/images/mighty7.jpg" data-lightbox="image-5">
                                <img src="/images/mighty7.jpg" className="device-thumb" style={{marginTop:"10px"}} alt="Mightywifi US and Global hotspot wifi device travel image" />
                            </a> */}
                            <a href="/images/mightywifi-cloud-4.jpg" className="device-link-thumb" data-lightbox="image-6">
                                <img src="/images/mightywifi-cloud-4.jpg" className="device-thumb" style={{marginTop:"10px"}} alt="Mightywifi US and Global hotspot wifi device wall charger image" />
                            </a>
                        </div>

                        <div className="col-md-7 services_clip pt-d-5p">
                            <div className="services_bg_pad">
                                <div className="row justify-content-center">
                                    <div className="col-lg-12">
                                        <div className="text-left device_boxes mt-3 rounded p-4">
                                            <p className="mb-0 mt-2">
                                                The MightyWifi mobile hotspot allows users to instantly and securely connect up to 10 devices optimally to a local cellular network via its cloud SIM technology. The MightyWifi works in over 150 countries at 4G LTE speeds. We offer a range of plans to best match your needs.
                                            </p>
                                            <div style={{clear:"both",height:"30px"}}></div>

                                            <div className="services_content mt-1">


                                                {/*<h2>Mightywifi</h2>*/}
                                                {/*<p className="mb-0 mt-2">
                                                        { product.description }
                                                    </p>*/}
                                                <div style={{clear:"both",height:"15px"}}></div>


                                                <div className="row">
                                                    <div className="col-lg-12">
                                                        <div className="form-group mt-1">
                                                            <strong>IMEI Number</strong>
                                                            <div className="tooltip-ex">
                                                                <strong><i className="mdi mdi-help-circle" style={{color:"#000000"}}></i></strong>
                                                                <span className="tooltip-ex-text tooltip-ex-right">
                                                                        <img src="/images/020719-002.jpg"/>
                                                                    </span>
                                                            </div>
                                                        </div>
                                                    </div>

                                                    <div className="col-lg-12">
                                                        <div className="form-group">
                                                            {/*<input name="imei" id="email" type="text"
                                                               className="form-control" placeholder="IMEI Number"
                                                               required="" onChange={this._onChange} value={this.state.imei} />*/}
                                                            <MaskedInput mask={[/\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/]} id="imei" placeholder="IMEI Number" className="form-control no-border-radius sim-card-field" name="imei" value={this.state.imei} type="text" onChange={this._onChange} required />
                                                            <div style={{clear:"both",height:"15px"}}></div>
                                                            <a href="javascript:void(0)" className="btn-white btn" onClick={this.validateIMEI}>Verify</a>
                                                        </div>
                                                    </div>
                                                </div>

                                                {/*{
                                                        (this.state.validateImei === false) ? (
                                                            <span>
                                                                <div style={{clear:"both",height:"15px"}}></div>
                                                                <span style={{color:"#da0905"}}>Your IMEI number is not verified. Please enter valid IMEI number and verify again.</span>
                                                            </span>
                                                        ) : null
                                                    }*/}

                                                {
                                                    (typeof this.state.errorMessage !== "undefined" && this.state.errorMessage !== null) ? (
                                                        <span>
                                                            <div style={{clear:"both",height:"15px"}}></div>
                                                            <span style={{color:"#da0905"}}>{this.state.errorMessage}</span>
                                                            </span>
                                                    ) : null
                                                }

                                                <div style={{clear:"both",height:"15px"}}></div>



                                                {/*{
                                                        (typeof this.state.validateImei === "undefined" || !this.state.validateImei) ? (
                                                            <div style={{clear:"both",height:"300px"}}></div>
                                                        ) : null
                                                    }*/}


                                                {/*{
                                                      (typeof this.state.validateImei !== "undefined" && this.state.validateImei !== null && this.state.validateImei === true) ? (*/}
                                                <div className="recharge-device-section">

                                                    <p>
                                                        {
                                                            (typeof this.state.validateImei !== "undefined" && this.state.validateImei !== null && this.state.validateImei === true) ? (
                                                                <span>Congratulations! Your IMEI number is verified.<br/></span>
                                                            ) : null
                                                        }
                                                        <strong>Please select a plan.</strong>
                                                    </p>

                                                    {/*<a onClick={() => this.setUseType("USA")} className={`btn btn-white mr-15` + ((this.state.useType && this.state.useType !== null && this.state.useType == 'USA') ?  ` active` : "")}>US Only</a>
                                                              <a onClick={() => this.setUseType("GLOBAL")} className={`btn btn-white` + ((this.state.useType && this.state.useType !== null && this.state.useType == 'GLOBAL') ?  ` active` : "")}>Global (US excluded)</a>*/}

                                                    {/*{
                                                                  (typeof this.countries !== "undefined" && this.countries !== null && typeof this.state.useType !== "undefined" && this.state.useType == "GLOBAL") ? (

                                                                      <div>
                                                                        <div style={{clear:"both",height:"15px"}}></div>

                                                                        <div className="row">
                                                                            <div className="col-lg-6">
                                                                                <select name="country" className="form-control max-width-200-px" id="country" onChange={this._onChange}>
                                                                                    <option value="">-- Select a Country or a Region --</option>
                                                                                    {
                                                                                        this.countries.map(
                                                                                            (country) => (
                                                                                                <option value={country._id}>{country.name}</option>
                                                                                            )
                                                                                        )
                                                                                    }
                                                                                </select>
                                                                            </div>
                                                                        </div>
                                                                      </div>

                                                                  ) : null
                                                              }*/}

                                                    <div className="row">
                                                        <div className="col-lg-8">
                                                            <select name="country" className="form-control max-width-200-px" id="country" onChange={this._onChange}>
                                                                <option value="">-- Select a Country or a Region --</option>
                                                                {
                                                                    this.countries.map(
                                                                        (country) => (
                                                                            <option value={country._id}>{country.name}</option>
                                                                        )
                                                                    )
                                                                }
                                                            </select>
                                                        </div>
                                                    </div>

                                                    <div id="mask" onClick="document.location='#';"></div>
                                                </div>


                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        {
                            (typeof this.state.country !== "undefined" && this.state.country !== null && this.state.country.description !== null && this.state.country.description !== '') ? (

                                <div className="col-lg-12">{this.state.country.description}</div>

                            ) : null
                        }

                        <div style={{clear:"both",height:"15px"}}></div>

                        <div className="col-lg-12">


                            <div>
                                {
                                    (typeof product.associated_products !== "undefined" && typeof this.state.useType !== "undefined" && this.state.useType !== null && (this.state.useType !== "GLOBAL" || (typeof this.state.country !== "undefined" && this.state.country !== null))) ? (
                                        <div>
                                            <div style={{clear:"both",height:"50px"}}></div>
                                            <div className="line"></div>
                                            <div style={{clear:"both",height:"15px"}}></div>
                                            <strong>Day Pass or Data Plan?</strong>
                                            <div style={{clear:"both",height:"15px"}}></div>
                                        </div>
                                    ) : null
                                }


                                {
                                    (typeof product.associated_products !== "undefined" && product.associated_products !== null && typeof this.state.useType !== "undefined" && this.state.useType !== null && (this.state.useType !== "GLOBAL" || (typeof this.state.country !== "undefined" && this.state.country !== null))) ?
                                        product.associated_products.map(
                                            associated_product => (
                                                <span>
                                                          <a className={`btn btn-white mr-15` + ((this.state.setAssocProductId && this.state.setAssocProductId !== null && this.state.setAssocProductId == associated_product._id) ?  ` active` : "")} onClick={() => this.setAssociatedProduct(associated_product._id)}>{associated_product.name}{((this.state.useType == "USA" && associated_product.type == "day_pass") ?  ` *` : "")}<br/><span style={{fontSize: "0.8rem",  whiteSpace: "pre-line"}}>{associated_product.shortDescription}</span></a>
                                                          </span>
                                            )
                                        )
                                        : null
                                }
                                {/*<a href="#" className="btn btn-outline-white">DAY PASS</a>*/}
                                {/*&nbsp;&nbsp;*/}
                                {/*<a href="#" className="btn btn-outline-white">DATA PACKAGE</a>*/}

                                <div style={{clear:"both",height:"15px"}}></div>


                                {/*{
                                              (typeof product.associated_products !== "undefined" && product.associated_products !== null && typeof this.state.useType !== "undefined" && this.state.useType !== null) ?
                                                  product.associated_products.map(
                                                      associated_product => (

                                                          <div style={{fontSize:"12px"}}>
                                                              <strong><i className="mdi mdi-help-circle"></i>{associated_product.name}</strong>
                                                              : {associated_product.shortDescription}
                                                              <br/>
                                                              <br/>
                                                          </div>

                                                      )
                                                  )
                                                  : null
                                          }*/}

                                {
                                    (typeof product.associated_products !== "undefined" && product.associated_products !== null && typeof this.state.useType !== "undefined" && this.state.useType !== null && this.state.useType == "USA") ?
                                        (

                                            <div style={{fontSize:"18px"}}>
                                                <strong className="uppercase">Day Pass</strong>
                                                : Day passes offer a more affordable rate and give 1GB per day, refreshing back to 1GB on the next day. This cost-efficient plan is ideal for your single trip where light usage is expected.
                                                <br/>
                                                * The Day Pass becomes active upon activation and expires at midnight each day according to U.S. Pacific Time (GMT-5), rather than being valid for a full 24 hours from the time of activation.
                                                <br/>
                                                * For a limited time period, UNLIMITED US multiple day passes are available for US travelers.
                                                <br/>
                                                <br/>
                                                <strong className="uppercase">Data Plan</strong>
                                                : Data plans offer a set amount of data for 30 days starting from the date of activation. Data usage is limited to the data size purchased. This plan is recommended if you want more flexibility in how you use your device.
                                                {/*<div>(300G Promotion @$90 ended on August 31st 2020)</div>*/}
                                                <br/>
                                                <br/>
                                            </div>
                                        )
                                        : null

                                }

                                {
                                    (typeof product.associated_products !== "undefined" && product.associated_products !== null && typeof this.state.useType !== "undefined" && this.state.useType !== null && this.state.useType == "GLOBAL" && typeof this.state.country !== "undefined" && this.state.country !== null) ?
                                        (

                                            <div style={{fontSize:"18px"}}>
                                                <strong className="uppercase">Day Pass</strong>
                                                : Day passes offer a more affordable rate and give 1GB per day, refreshing back to 1GB on the next day. This cost-efficient plan is ideal for your single trip where light usage is expected.
                                                <br/>
                                                * The Day Pass becomes active upon activation and expires at midnight each day according to U.S. Pacific Time (GMT-5), rather than being valid for a full 24 hours from the time of activation.
                                                <br/>
                                                <br/>
                                                <strong className="uppercase">Data Plan</strong>
                                                : Data plans offer a set amount of data for 30 days or 180 days depending on your data size starting from the date of activation. Data usage is limited to the data size purchased. This plan is recommended if you want more flexibility in how you use your device.
                                                <br/>
                                                <br/>
                                            </div>
                                        )
                                        : null

                                }

                                <div style={{clear:"both",height:"15px"}}></div>

                                {
                                    (typeof product.associated_products !== "undefined" && typeof this.state.useType !== "undefined" && this.state.useType !== null) ?
                                        product.associated_products.map(
                                            associated_product => (

                                                (this.state.setAssocProductId !== null && associated_product._id == this.state.setAssocProductId) ? (

                                                    <div className="assoc_product">
                                                        {/*  <strong>{associated_product.name}</strong> */}
                                                        {/* <div style={{clear:"both",height:"15px"}}></div> */}

                                                        {
                                                            (typeof associated_product.recurring_profiles !== "undefined" && associated_product.recurring_profiles.length > 0) ? (
                                                                associated_product.recurring_profiles.map(
                                                                    recurring_profile => (
                                                                        (recurring_profile.status === 1 && recurring_profile.price > 0) ? (
                                                                            <button onClick={() => this.onRecurringProfileSelect(associated_product,recurring_profile)} className={`btn btn-white mr-15 mb-3 product-btn` + ((this.state.recurringProfile && this.state.recurringProfile !== null && this.state.recurringProfile._id == recurring_profile._id) ?  `btn btn-white active mr-15 mb-3 product-btn` : "")}>{recurring_profile.name} <strong>${recurring_profile.price}</strong></button>
                                                                        ) : null
                                                                    )
                                                                )
                                                            ) : null
                                                        }

                                                        <div style={{clear:"both",height:"15px"}}></div>

                                                        {
                                                            ((typeof associated_product.options !== "undefined" && associated_product.options.length > 0) ?  (

                                                                associated_product.options.map(
                                                                    option => (

                                                                        (option.type == "date") ? (
                                                                            <div className="row col">
                                                                                <div className="form-group mt-3">
                                                                                    <strong>Start Date</strong>
                                                                                </div>
                                                                                <div className="col-lg-2">
                                                                                    <div className="form-group mt-3">
                                                                                        <DatePicker
                                                                                            className="form-control data-field"
                                                                                            selected={this.state.startDate}
                                                                                            minDate={moment()}
                                                                                            onChange={this.onStartDateChange}
                                                                                            id="startDate"
                                                                                            placeholderText="Start Date"
                                                                                            onChangeRaw={event => {
                                                                                                event.preventDefault();
                                                                                            }}
                                                                                        />
                                                                                    </div>
                                                                                </div>
                                                                            </div>
                                                                        ) : null
                                                                    )
                                                                )
                                                            ) : null)
                                                        }

                                                        {/*{
                                                                      (typeof this.state.country !== "undefined" && typeof this.state.country.mos_products !== "undefined" && this.state.country.mos_products.length > 0) ? (
                                                                          this.state.country.mos_products.map(
                                                                              mos_product => (
                                                                                  (mos_product.price > 0) ? (
                                                                                      <span>
                                                                  <button onClick={() => this.onMosProductSelect(mos_product)} className={`btn btn-outline-white background-transparent` + ((this.state.mosProduct && this.state.mosProduct !== null && this.state.mosProduct._id == mos_product._id) ?  `btn btn-outline-white background-transparent active` : "")}>{mos_product.name}<br/>${mos_product.price}</button>
                                                                                          &nbsp;&nbsp;
                                                              </span>
                                                                                  ) : null
                                                                              )
                                                                          )
                                                                      ) : (

                                                                      (typeof associated_product.recurring_profiles !== "undefined" && associated_product.recurring_profiles.length > 0) ? (
                                                                          associated_product.recurring_profiles.map(
                                                                              recurring_profile => (
                                                                                  (this.getPriceByUseType(recurring_profile) > 0) ? (
                                                                                  <span>
                                                                  <button onClick={() => this.onRecurringProfileSelect(associated_product,recurring_profile)} className={`btn btn-outline-white background-transparent` + ((this.state.recurringProfile && this.state.recurringProfile !== null && this.state.recurringProfile._id == recurring_profile._id) ?  `btn btn-outline-white background-transparent active` : "")}>{recurring_profile.name}<br/>${this.getPriceByUseType(recurring_profile)}</button>
                                                                                      &nbsp;&nbsp;
                                                              </span>
                                                                                  ) : null
                                                                              )
                                                                          )
                                                                      ) : null

                                                                      )
                                                                  }*/}
                                                        <div style={{clear:"both",height:"15px"}}></div>
                                                    </div>
                                                ) : null
                                            )
                                        )
                                        : null
                                }
                            </div>

                            {
                                (typeof product.associated_products !== "undefined" && typeof this.state.useType !== "undefined" && this.state.useType !== null && (this.state.useType !== "GLOBAL" || (typeof this.state.country !== "undefined" && this.state.country !== null))) ? (
                                    <div className="row">
                                        <div className="col-md-12">
                                            <div style={{clear:"both",height:"40px"}}></div>
                                        </div>
                                        <div className="col-md-8">
                                            <h2 className="mb-0 SansSerif bold100">
                                                YOUR TOTAL IS <span className="bold700">${this._getSubTotal()}</span>
                                            </h2>
                                        </div>
                                        <div className="col-md-4 text-right">
                                            <a href="#" className="btn btn-orange mr-15" onClick={this.addToCart}>CONTINUE</a>
                                            <a className="btn btn-white" onClick={() => this.reset()}>RESET</a>
                                        </div>
                                    </div>
                                ) : null
                            }

                            {
                                /*(
                                    typeof this.state.validateImei !== "undefined" && this.state.validateImei !== null && this.state.validateImei === true &&
                                    typeof this.state.useType !== "undefined" && this.state.useType !== null &&
                                    typeof this.state.setAssocProductId !== "undefined" && this.state.setAssocProductId !== null &&
                                    typeof this.state.recurringProfile !== "undefined" && this.state.recurringProfile !== null
                                ) ? (*/
                                /*) : null*/
                            }

                            {/*) : null }*/}
                        </div>


                    </div>
                </div>
            </section>

        )
    }
}


RechargeDeviceCart.contextTypes = {
    router: PropTypes.object.isRequired
};

function mapStateToProps(state) {
    return {
        auth: state.auth,
        cart: state.cart,
        products: state.product.products,
        countries: state.country.countries
    };
}

export default withRouter(connect(
    mapStateToProps,
    { getRechargeDeviceProduct, getCountries, validateDeviceIMEI, addToCart, addFlashMessage, setRedirectPath, getCart }
)(RechargeDeviceCart));



// WEBPACK FOOTER //
// ./src/pages/rechargeDevice/RechargeDevice.js